import { Stack } from "expo-router";

/**
 * A native deep link can enter at any recital leaf without first visiting the
 * library. Anchor this browse stack at Recitals so Back owns a real native
 * screen to pop instead of replacing the leaf with a logical parent.
 */
export const unstable_settings = {
  initialRouteName: "index"
};

export default function RecitalsLayout() {
  return (
    <Stack
      screenOptions={{
        contentStyle: { backgroundColor: "transparent" },
        headerShown: false,
        orientation: "portrait",
        statusBarStyle: "light"
      }}
    />
  );
}
